export enum UserRoles {
  None = 0,
  SuperAdmin = 1,
  BizboxAdmin = 2,
  GroupAdmin = 3,
  CoGroupAdmin = 4,
  FacilityAdmin = 5,
  CoFacilityAdmin = 6,
  User = 7,
  BizboxUser = 8,
}

export const getUserRoleString = (roleValue: number): string => {
  const res = UserRoles[roleValue] as string;
  return res;
};

export const getRoleNumber = (role: UserRoles): number => {
  return role;
};

export const pascalToRegular = (pascal: string): string => {
  if (pascal === undefined) {
    return "";
  }
  const spaced = pascal
    .replace(/([a-z])([A-Z])/g, "$1 $2") // Insert space before uppercase letters
    .replace(/^./, (char) => char.toUpperCase()); // Capitalize the first letter

  // If string starts with "Co ", hyphenate as "Co-..." (e.g., Co-Facility Admin)
  return spaced.replace(/^Co\s/, "Co-");
};
